import { CountUp } from 'countup.js';
import axios from 'axios';
import { http } from './http';
import { handleCaptchaExpired } from './handleCaptchaExpired';
import { useStore } from 'vuex';
import { getCurrentScope } from 'vue';

const BASE_VIEWPORT_WIDTH = 1440;
const BASE_MOBILE_VIEWPORT_WIDTH = 360;
const BASE_MOBILE_BREAKPOINT = 1000;

/**
 * **DO NOT USE!**
 * 
 * TODO: code what used this needed refactoring
 * 
 * if you need a store get it from components or composables
 * @deprecated
 */
const getStore = () => {
	const hasScope = getCurrentScope();
	if (hasScope) {
		return useStore();
	}

	const app = document.querySelector('#app');
	return app.__vue_app__.config.globalProperties.$store;
}

export function px2vw(px, base = innerWidth) {
	return px / (base / 100);
}

export const px2local = (innerWidth, desk, mob = desk) => {
	let scale = 1;
	const isMobile = innerWidth <= BASE_MOBILE_BREAKPOINT;
	if (isMobile) {
		scale = innerWidth / BASE_MOBILE_VIEWPORT_WIDTH;
	} else if (innerWidth <= BASE_VIEWPORT_WIDTH) {
		scale = innerWidth / BASE_VIEWPORT_WIDTH;
	} else {
		scale = 1;
	}

	return isMobile ? mob * scale : desk * scale;
}

export function isScrolledIntoView(el) {
	var rect = el.getBoundingClientRect();
	var elemTop = rect.top;
	var elemBottom = rect.bottom;

	var isVisible = elemTop >= window.innerHeight || elemBottom <= window.innerHeight;
	return isVisible;
}

export function getQueryParameterByName(name, url) {
	if (!url) url = window.location.href;
	name = name.replace(/[[\]]/g, "\\$&");
	var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
		results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/**
 * Отправка номера телефона для получения кода в СМС
 * @param {date} phone - номер телефона в формате +7 (000) 000 00 00
 * @param {string} id - id формы. необходимо согласововывать с бэком
 * @param {string} sessid - id сессии
 * @param {string} uid - аттрибут uid
 */
export function sendCode(phone, id, sessid, uid) {

    let data = {
        "jsonrpc": "2.0",
        "method": "sms.sendCode",
        "params": {
            "tel": phone
        },
        "id": id
    }

	uid = uid || '';
	if (uid !== '') {
		data = Object.assign(data, {"params": {"tel": phone, "attributes": {"uid": uid}}});
	}

	return axios.post(
		'/rpc/?sessid=' + sessid,
		data,
		{
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
			}
		}
	);
}

/**
 * Отправка СМС для подтверждения телефона
 * @param {string} code - код из СМС
 * @param {string} id - id формы. необходимо согласововывать с бэком
 * @param {string} sessid - id сессии
 * @param {string} uid - аттрибут uid
 */
export function verifyCode(code, id, sessid, uid) {

	let data = {
		"jsonrpc": "2.0",
		"method": "sms.verifyCode",
		"params": {
			"code": code
		},
		"id": id
	};

	uid = uid || '';
	if (uid !== '') {
		data = Object.assign(data, {"params": {"code": code, "attributes": {"uid": uid}}});
	}

	return axios.post(
		'/rpc/?sessid=' + sessid,
		data,
		{
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
			}
		}
	);
}

/**
 * Отправка номера телефона для получения кода в СМС
 * @param {date} draftUid - id заявки
 * @param {string} id - id формы. необходимо согласововывать с бэком
 * @param {string} sessid - id сессии
 */
 export function sendCodeDraft(draftUid, id, sessid) {

	return axios.post(
		'/rpc/?sessid=' + sessid,
		{
			"jsonrpc": "2.0",
			"method": "sms.sendLoansCode",
			"params": {
				"uid": draftUid
			},
			"id": id
		},
		{
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
			}
		}
	);
}

export function getSessid() {

	return axios.get(
		'/local/ajax/sessid.php',
		{ withCredentials: true }
	)
}

/**
 *  Подбираем ошибку из тела ответа АПИ
 * @param {Error} err
 * @returns {string} строка с текстом ошибки
 */
export const getErrorText = (err) => {
	let text = 'Неизвестная ошибка. Повторите попытку позже.';
	if (err.response?.data.message) {
		text = err.response?.data.message;
	} else if ( err.response?.data.errors ) {
		try {
			text = err.response.data.errors
				.map((e) => {
					return typeof e.details === 'string' ? `${e.title}: ${e.details}` : Object.values(e.details).join(';\n');
				})
				.join(';\n');
		} catch (error) {
			//
		}

	}
	return text;
}

/**
 * Рекурсивная фунция сериализации объекта в вид get-параметров
 */
function serializeObject(obj, prefix) {
	let str = [],
		p;
	for (p in obj) {
		if (obj.hasOwnProperty(p)) {
			const k = prefix ? prefix + "[" + p + "]" : p,
						v = obj[p];
			const result = (v !== null && typeof v === "object")
				? serializeObject(v, k)
				: v !== undefined
					? k + "=" + v
					: '';
			if (result) str.push(result);
		}
	}

	return str.join("&");
}

export const EMbSlotType = {
	MB: 'MB',
	EXT: 'EXT',
	EXT_SAT: 'EXT_SAT',
	EXT_SUN: 'EXT_SUN',
}

/**
 * Получение городов NEW
 * @param {object} [filter={}]
 * @param {string} filter.regionCode - код региона,
 * @param {string} filter.productCode - идентификатор продукта,
 * @param {EMbSlotType} filter.type - тип слота,
 * @param {string} [sort="name"]
 * @param {object} [options={}]
 * @param {string=} options.key - ключ для идентификаци запроса,
 * по этому ключу отменяется предыдущий запрос с таким же ключом,
 * если он не успел завершиться
 */
export function getMbCities(filter = {}, sort = 'city', options = {}) {

	if (!filter.regionCode || !filter.productCode) return Promise.reject('request must contains regionCode & productCode');
	if (typeof filter.regionCode !== 'string') return Promise.reject('regionCode parameter must be string type');
	if (filter.type && !Object.values(EMbSlotType).includes(filter.type)) return Promise.reject('type parameter validation type error');

	const data = {
		data: {
			type: 'mbGetCities',
			attributes: {
				region: filter.regionCode,
				product: filter.productCode
			}
		}
	};

	const params = {
		sort,
	};

	return http.post(`/rest/v1/mb/cities`, data, {
		headers: {
			'Content-Type': 'application/vnd.api+json',
			'Accept': 'application/vnd.api+json',
		},
		params,
		...options,
		includeSessionId: true,
	})
		.catch((err) => {
			if ([419, 403].includes(err.response?.status)) {
				handleCaptchaExpired;
			}
			else if (err.response?.status === 500) {
				const store = getStore();
				store.commit('meeting/SET_CITIES_ERROR', err.response?.status);
			}
		})
		.then((res) => {
			if (!filter.type) return res.data.data.attributes;

			res.data.data.attributes.cities = res.data.data.attributes.cities
				.filter((city) => filter.type === EMbSlotType.MB ? city.isMbActive : city.isExtActive)

			return res.data.data.attributes;
		});
}

/**
 * Получает список слотов из АС мобильный банкир
 * @param {object} filter
 * @param {string} filter.cityName - город
 * @param {string} filter.productId - ид продукта
 * @param {string} filter.startDate - дата DD.MM.YYYY
 * @param {string} filter.endDate - дата DD.MM.YYYY
 * @param {object} options
 * @param {string} options.key
 * @returns {Promise<object>}
 */
export const getMbSlots = (filter = {}, options = {}) => {
	const data = {
		data: {
			type: 'mbGetSlots',
			attributes: {
				city: filter.cityName,
				product: filter.productId,
				startDate: filter.startDate,
				endDate: filter.endDate,
			},
		},
	};

	return http.post(`/rest/v1/mb/slots`, data, {
		headers: {
			'Content-Type': 'application/vnd.api+json',
			'Accept': 'application/vnd.api+json',
		},
		...options,
		includeSessionId: true,
	})
		.catch((err) => {
			if ([419, 403].includes(err.response?.status)) {
				handleCaptchaExpired;
			}
			else if (err.response?.status === 500) {
				const store = getStore();
				store.commit('meeting/SET_SLOTS_ERROR', err.response?.status);
			}
		})
		.then((res) => {
			const store = getStore();
			store.commit('meeting/SET_SLOTS_ERROR', res.status);
			return res.data.data.attributes.citySlots.workingDays;
		});
};

/**
 * Получает список слотов из bitrix для эскроу
 * @param {object} filter
 * @param {string} filter.office - офис
 * @param {string} filter.date - дата DD.MM.YYYY
 * @param {object} options
 * @param {string} options.key
 * @returns {Promise<object>}
 */
export const getEscrowSlots = (filter = {}, options = {}) => {
	const params = {
		date: filter.date,
	};

	return http.get(`/rest/v1/appointments/${filter.office}/escrow/freeSlots`, {
		headers: {
			'Content-Type': 'application/vnd.api+json',
			'Accept': 'application/vnd.api+json',
		},
		params,
		...options,
		includeSessionId: true,
	})
		.catch(handleCaptchaExpired)
		.then((res) => {
			return res.data.data.attributes.slots;
		});
};

/**
 * Получение офисов
 */
export function getOffices(cityId) {


	let params = {
		page: {
			number: 1,
			size: 50,
		},
		sort: 'name'
	};

	return axios.get('/rest/v1/offices/byCity/' + cityId, {
		headers: {
			'Content-Type': 'application/vnd.api+json',
			'Accept': 'application/vnd.api+json',
		},
		params: params,
		paramsSerializer(params) {
			return serializeObject(params);
		},
	})
}

/**
 * Получение регионов
 * @param {object} addParams - дополнительные параметры для фильтра
 * @param {any} options.key - ключ для идентификаци запроса,
 * по этому ключу отменяется предыдущий запрос с таким же ключом,
 * если он не успел завершиться
 */
 export function getRegionsV2(addParams, sort = 'name', options = {}) {

	addParams = addParams || '';

	let params = {
		page: {
			number: 1,
			size: 1200,
		},
		sort: sort
	};

	if (addParams) {
		Object.assign(params, addParams);
	}

	return http.get('/rest/v2/network/regions', {
		headers: {
			'Content-Type': 'application/vnd.api+json',
			'Accept': 'application/vnd.api+json',
		},
		params: params,
		paramsSerializer(params) {
			return serializeObject(params);
		},
        ...options,
	});
}

/**
 * Получение городов
 * @param {object} [addParams={}] - дополнительные параметры для фильтра
 * @param {string} [sort="name"]
 * @param {object} [options={}] - options,
 * @param {string=} options.key - ключ для идентификаци запроса,
 * по этому ключу отменяется предыдущий запрос с таким же ключом,
 * если он не успел завершиться
 */
 export function getCitiesV2(addParams = {}, sort = 'name', options = {}) {

	const params = {
		// page: {
		// 	number: 1,
		// 	size: 1800,
		// },
		sort,
	};

	if (addParams) {
		Object.assign(params, addParams);
	}

	return http.get('/rest/v2/network/cities', {
		headers: {
			'Content-Type': 'application/vnd.api+json',
			'Accept': 'application/vnd.api+json',
		},
		params,
		paramsSerializer(params) {
			return serializeObject(params);
		},
      ...options,
	});
}

/**
 * Получение офисов
 * @param {any} options.key - ключ для идентификаци запроса,
 * по этому ключу отменяется предыдущий запрос с таким же ключом,
 * если он не успел завершиться
 */
export function getOfficesV2(cityId, addParams, sort = 'name', options = {}) {


	let params = {
		page: {
			number: 1,
			size: 50,
		},
		sort: sort,
		where: {}
	};

	if (addParams) {
		Object.assign(params.where, addParams);
	}

	if (cityId) {
		params.where['address.city'] = cityId;
	}

	return http.get('/rest/v2/network/offices', {
		headers: {
			'Content-Type': 'application/vnd.api+json',
			'Accept': 'application/vnd.api+json',
		},
		params: params,
		paramsSerializer(params) {
			return serializeObject(params);
		},
        ...options,
	})
}

/**
 * Вычисляет имя города по ip в сервисе dadata
 * @returns {string|undefined} - имя города
 */
export const detectCity = async () => {
    const baseUrl = window.config.dadata_url;
    const path = 'iplocate/address';
    let cityName;

    try {
        const { data: { location: { data: { city }}} } = await axios.get(baseUrl+path);
        cityName = city;
    } catch (e) {
        //
    }

    return cityName;
};

/**
 * Получение ЦИКов
 */
 export function getCikV2(cityId) {

	let params = {
		page: {
			number: 1,
			size: 50,
		},
		sort: 'name',
		where: {}
	};

	if (cityId) {
		params.where['address.city'] = cityId;
	}

	return axios.get('/rest/v2/network/ciks', {
		headers: {
			'Content-Type': 'application/vnd.api+json',
			'Accept': 'application/vnd.api+json',
		},
		params: params,
		paramsSerializer(params) {
			return serializeObject(params);
		},
	})
}

/**
 * Получение банкоматов
 */
 export function getAtmsV2(cityId, addParams) {


	let params = {
		page: {
			number: 1,
			size: 50,
		},
		sort: 'name',
		where: {}
	};

	if (addParams) {
		Object.assign(params.where, addParams);
	}

	if (cityId) {
		params.where['location'] = cityId;
	}

	return axios.get('/rest/v2/network/atms', {
		headers: {
			'Content-Type': 'application/vnd.api+json',
			'Accept': 'application/vnd.api+json',
		},
		params: params,
		paramsSerializer(params) {
			return serializeObject(params);
		},
	})
}

/**
 * Получение банкоматов партнеров (альфа-банк)
 */
export function getPartnerAtmsV2(cityId, addParams) {


	let params = {
		page: {
			number: 1,
			size: 50,
		},
		sort: 'name',
		where: {}
	};

	if (addParams) {
		Object.assign(params, addParams);
	}

	if (cityId) {
		params.where['location'] = cityId;
	}

	return axios.get('/rest/v2/network/partnerAtms', {
		headers: {
			'Content-Type': 'application/vnd.api+json',
			'Accept': 'application/vnd.api+json',
		},
		params: params,
		paramsSerializer(params) {
			return serializeObject(params);
		},
	})
}

export function getCaretPos(input) {
    let range, bookmark, caret_pos;
    if (document.selection && document.selection.createRange) {
        range = document.selection.createRange();
        bookmark = range.getBookmark();
        caret_pos = bookmark.charCodeAt(2) - 2;
    } else {
        if (input.setSelectionRange)
            caret_pos = input.selectionStart;
    }

    return caret_pos;
}

export function setCaretPos(el, pos) {
    setTimeout(() => { // обёртка setTimeout нужна для iOS
        el.setSelectionRange(pos, pos);
    }, 1)
}

// проверка на необходимость ранее выданного паспорта по логике ФИСа
export function isNeedPrevPassport(bday, issueDate) {
	if(!bday || !issueDate) return true;

	let convertDate = (date) => {
		return new Date(date.split('.').reverse().join('-'));
	}

	let passportDate = convertDate(issueDate),
		date240 = convertDate(bday),
		date243 = convertDate(bday),
		date540 = convertDate(bday),
		date543 = convertDate(bday),
		passport60 = convertDate(issueDate);

	date240.setMonth(date240.getMonth() + 240); // выдача паспорта в 20 лет, нижняя граница
	date243.setMonth(date243.getMonth() + 243); // выдача паспорта в 20 лет, верхняя граница
	date540.setMonth(date540.getMonth() + 540); // выдача паспорта в 45 лет, нижняя граница
	date543.setMonth(date543.getMonth() + 543); // выдача паспорта в 45 лет, верхняя граница
	passport60.setMonth(passport60.getMonth() + 60);

	if(passport60 > new Date()) {
		if (passportDate < date240) {
			return false;
		}
		else if ( (passportDate > date243) && (passportDate < date540) ) {
			return false;
		}
		else if ( passportDate > date543 ) {
			return false;
		}
		else {
			return true;
		}
	}
	return true;
}

export const Clipboard = (function(window, document, navigator) {
	var textArea,
		copy;

	function isOS() {
		return /iPad|iPhone|iPod/.test(navigator.platform);
	}

	function createTextArea(text) {
		textArea = document.createElement('textArea');
		textArea.value = text;
		document.body.appendChild(textArea);
	}

	function selectText() {
		var range,
			selection;

		if (isOS()) {
			range = document.createRange();
			range.selectNodeContents(textArea);
			selection = window.getSelection();
			selection.removeAllRanges();
			selection.addRange(range);
			textArea.setSelectionRange(0, 999999);
		} else {
			textArea.select();
		}
	}

	function copyToClipboard() {
		document.execCommand('copy');
		document.body.removeChild(textArea);
	}

	copy = function(text) {
		createTextArea(text);
		selectText();
		copyToClipboard();
	};

	return {
		copy: copy
	};
})(window, document, navigator);

/**
 * Плавный скролл к элементу по id или class с учетом отступа для плавающей шапки
 * @param {string | HTMLElement} id -
 */
function scrollTo(el, offsetAdd = 0) {
    if (!el) {
        // eslint-disable-next-line no-console
        console.error('Cant find elem for scroll to him');
        return
    }

		const getOffset = () => {
			// don't repeat nowhere
			const store = getStore();
			const offset = store.getters?.['app/mainTopOffsetScrolled'];
			return offset;
		};

    const offset = getOffset() + offsetAdd;
    const bodyRect = document.body.getBoundingClientRect().top;
    const elRect = el.getBoundingClientRect().top;
    const elPosition = elRect - bodyRect;
    const offsetPosition = elPosition - offset;

    window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
    });
}
export function scrollToElem(id) {
	const el = id instanceof HTMLElement ? id : document.getElementById(id);
	scrollTo(el);
}

export function scrollToSelect(select, offsetAdd) {
    const el = select instanceof HTMLElement ? select : document.querySelector(select);
    scrollTo(el, offsetAdd);
}

/**
 * Переводит дату new Date() в формат dd.mm.yyy
 * @param {date} date - дата в формате Wed Dec 09 2020 00:11:22 GMT+0300 (Москва, стандартное время)
 */
export function convertDateToRus(date) {
	var day = +date.getDate(),
		month = +date.getMonth() + 1,
		year = +date.getFullYear();

	if(day < 10) day = '0' + day;
	if(month < 10) month = '0' + month;

	return [day, month, year].join('.');
}
/**
 * Переводит текст в латиницу
 * @param {string} str - любая строка
 */
export function convertToLatin(str) {
	const min = 1072,
		max = 1105;

	const ru = [
		"a", "b", "v", "g", "d", "e", "j", "z", "i", "i", "k", "l", "m", "n", "o", "p", "r", "s", "t", "u", "f", "h", "c", "ch", "sh", "shch", "", "y", "", "e", "u", "ya", "", "yo",
	];
	let translate = "";

	for (let i = 0; i < str.length; i++) {
		const charCode = str[i].toLowerCase().charCodeAt(0);
		if (charCode >= min && charCode <= max) {
			let newChar = ru[charCode - min];
			if (str[i] == str[i].toUpperCase()) {
				if (newChar.length > 1) {
					newChar = newChar.split("").reduce((prev, next, index) => {
						if (index == 1) {
							return prev.toUpperCase() + next;
						} else {
							return prev + next;
						}
					});
				} else {
					newChar = newChar.toUpperCase();
				}
			}
			translate += newChar;
		} else {
			translate += str[i];
		}
	}
	return translate;
}

/**
 * Возвращает cookie если есть или undefined
 * @param {string} name - Имя куки
 */
export function getCookie(name) {
	var matches = document.cookie.match(new RegExp(
		"(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + "=([^;]*)"
	));
	return matches ? decodeURIComponent(matches[1]) : undefined;
}

/**
 * Уcтанавливает cookie
 * @param {string} name - Имя куки
 * @param {string} value - Значение куки
 * @param {object} props - Опции
 */
export function setCookie(name, value, props) {
	props = props || {};
	var exp = props.expires;
	if (typeof exp == "number" && exp) {
		var d = new Date();
		d.setTime(d.getTime() + exp*1000);
		exp = props.expires = d;
	}
	if(exp && exp.toUTCString) { props.expires = exp.toUTCString() }
	value = encodeURIComponent(value)
	var updatedCookie = name + "=" + value
	for(var propName in props){
		updatedCookie += "; " + propName;
		var propValue = props[propName];
		if(propValue !== true){ updatedCookie += "=" + propValue; }
	}
	document.cookie = updatedCookie;
}

/**
 * Удаляет cookie
 * @param {string} name - Имя куки
 */
export function deleteCookie(name) {
	setCookie(name, null, { expires: -1 });
}

export function sortCitiesAlphabetically(array, arrKey) {
	array.sort((a, b) => {
		if (a[arrKey].toLowerCase() > b[arrKey].toLowerCase()) {
			return 1;
		}
		if (a[arrKey].toLowerCase() < b[arrKey].toLowerCase()) {
			return -1;
		}
		return 0;
	});

	const mow = array.filter(item => item[arrKey] === 'Москва')[0];
	const spb = array.filter(item => item[arrKey] === 'Санкт-Петербург')[0];

	array.forEach((item, i) => {
		if (item[arrKey] === 'Москва' || item[arrKey] === 'Санкт-Петербург') {
			array.splice(i, 1);
		}
	});

	array.unshift(mow, spb);

	return array;
}

export function sortAlphabetically(array, arrKey) {
	array.sort((a, b) => {
		if (a[arrKey].toLowerCase() > b[arrKey].toLowerCase()) {
			return 1;
		}
		if (a[arrKey].toLowerCase() < b[arrKey].toLowerCase()) {
			return -1;
		}
		return 0;
	});
	return array;
}

export function isMobile() {
	return window.innerWidth <= 1000 ? true : false;
}

export function createImgForPixel(url) {
    let img = document.createElement('img');
	img.src = url;
	img.width = 1;
	img.height = 1;
	document.body.prepend(img);
}

export function animateNumbers(elem, val, currency = '', decimalPlaces = 0) {
	if (!elem) return;
	var prevVal = elem.getAttribute('data-prev') || 0;
	var options = {
		startVal: prevVal,
		duration: .5,
		separator: ' ',
		decimal: ',',
		suffix: currency ? ' ' + currency : '',
		decimalPlaces: (val).toString().match(/.00$/) ? 0 : decimalPlaces
	}

	if (prevVal != val) {
		var num = new CountUp(elem, val, options)
		if (!num.error) {
			num.start()
			elem.setAttribute('data-prev', val)
		}
	}
}

export function stringToFloat(string) {
    return Number(string.replace(',', '.'))
}


export function getParentByClass(element, className) {
    let res = [];
    while ((element = element.parentElement)) {
        if (element.matches(className)) { res.push(element) }
    }
    return res[0];
}

export function isHidden(element) {
    return element.offsetParent === null ? true : false
}

export function getSiblings(elem) {
	var siblings = [];
	var sibling = elem.parentNode.firstChild;

	while (sibling) {
		if (sibling.nodeType === 1 && sibling !== elem) {
			siblings.push(sibling);
		}
		sibling = sibling.nextSibling
	}

	return siblings;
}

export function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

export function hasDuplicates(arr) {
    return arr.filter((item, index) => arr.indexOf(item) !== index).length > 0
}

export function prettyPeriodInYears(valMonths) {
    if (valMonths < 0) return [];
    let year = Math.floor(valMonths/12);
    let month = valMonths % 12;

    if (year < 0) {
        year = 0;
        return [0, month]
    } else {
        return [year, month]
    }
}
